import mainHero from "../images/bg1-mobile.png";
import mainLogo from "../images/main-logo.png";

function Section1() {
  const handleClick = () => {
    window.open(
      "https://donor.southtexasblood.org/donor/store/preview?utm_source=double_my_impact&utm_medium=landing_page&utm_campaign=twa_dontate&utm_content=stb&t",
      "_blank",
    );
  };
  return (
    <>
      <div className="relative md:bg-hero1 xl:bg-hero1 bg-[#2F2F2F] bg-cover bg-no-repeat bg-center text-white m-0 ">
        <img
          src={mainHero}
          className="flex md:hidden object-cover h-full w-full mx-auto"
          alt="Stuff the Bus"
        />
        <div className="flex flex-col justify-center md:max-w-[600px] xl:max-w-[750px] 2xl:max-w-[1100px] font-montserrat text-white flex-1 gap-6 lg:gap-8 2xl:gap-10 -mt-40 md:-mt-0 pb-8 md:pb-36 2xl:pb-48 md:pt-20  px-[7%] sm:px-[7%]">
          {/* <div className="text-center md:text-left">
            <span className=" text-[36px] md:text-[42px] 2xl:text-[90px] leading-[1.2] uppercase [text-shadow:0_2px_6px_rgba(3,3,12,.9)]">
              Help Fight Hunger
            </span>
          </div> */}
          <img
            src={mainLogo}
            alt="Main Logo"
            className="w-[380px] md:w-[500px] 2xl:w-[800px] mx-auto md:mx-0 pb-0 2xl:pb-12"
          />
          <div className="-mt-3 md:-mt-0 text-center md:text-left text-[18px] md:text-[20px] 2xl:text-[26px] max-w-2xl font-medium leading-[1.5] [text-shadow:0_2px_6px_rgba(0,3,14,.67)]">
            <strong>Double your impact —</strong>{" "}
            <span className="text-[#D6D6D6] md:text-white">
              Donate blood, earn points, and transform your Donor Reward Points
              into life-changing camp experiences for children who are battling
              or have battled cancer!
            </span>
          </div>
          <button
            className="mx-auto md:mx-0 donate-btn1 donate-btn "
            onClick={handleClick}
          >
            Donate points
          </button>
        </div>
      </div>
    </>
  );
}

export default Section1;
